import { IGoogleTagManager } from '../types/googleTagManager';

export const defaultGoogleTagManager: IGoogleTagManager = {
  head: '',
  body: '',
};
